import React, { useEffect, useState } from "react";
import { Card, Button, Typography, Segmented, Divider, Col } from "antd";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import ArrowRightIcon from "../../../../Theme/CustomIcons/Icons/Arrow/ArrowRightIcon";
import MessageTextIcon from "../../../../Theme/CustomIcons/Icons/Emails,Messages/MessageTextIcon.js";
import NotificationIconSVG from "../../../../Theme/CustomIcons/Icons/Notification/NotificationIcon.js";
import { getLimitedNotificationsAction } from "../../../../store/action/admin/limitedNotisActions.js";
import { getLimitedAnnouncementAction } from "../../../../store/action/admin/limitedAnnouncementActions.js";
import CustomLoaderIcon from "../../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon.js";
import MoreEmptyState from "../../../../Theme/EmptyStates/MoreEmptyStates/MoreEmptyState";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const NotificationCard = () => {
  const dispatch = useDispatch();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const themeDefault = useSelector((state) => state.themeDefault);
  const primaryColor = themeDefault?.info?.colorPrimary;
  const isDefaultTheme = themeDefault?.info?.themeColor === "default";
  const [activeTab, setActiveTab] = useState("notification");

  const {
    loading: notificationsLoading,
    notifications,
    error: notificationsError,
  } = useSelector((state) => state.limitedNotifications);

  const {
    loading: announcementsLoading,
    notifications: announcements,
    error: announcementsError,
  } = useSelector((state) => state.limitedAnnouncement);

  useEffect(() => {
    if (activeTab === "notification") {
      dispatch(getLimitedNotificationsAction());
    } else {
      dispatch(getLimitedAnnouncementAction());
    }
  }, [dispatch, activeTab]);

  // Function to format date
  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return "";

    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Format time with AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12 for 12 AM
    const timeStr = `${hours}:${minutes} ${ampm}`;

    return `${month} ${day}, ${year} ${timeStr}`;
  };

  const currentData =
    activeTab === "notification" ? notifications : announcements;
  const loading =
    activeTab === "notification" ? notificationsLoading : announcementsLoading;
  const error =
    activeTab === "notification" ? notificationsError : announcementsError;

  // Proper check if there's data to display
  const hasData =
    currentData && Array.isArray(currentData) && currentData.length > 0;

  return (
    <Col xs={24}>
      <Card
        className={css`
          height: 542px;
          width: 480px;
          display: flex;
          flex-direction: column;
          @media (max-width: 576px) {
            width: 100%;
            height: auto;
            min-height: 542px;
          }
        `}
        bodyStyle={{
          padding: "24px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Segmented
          value={activeTab}
          onChange={setActiveTab}
          options={[
            {
              label: (
                <div className="segmented-item">
                  <NotificationIconSVG className="icon" />
                  <Text strong level="h5" className="segmented-text">
                    Notification
                  </Text>
                </div>
              ),
              value: "notification",
            },
            {
              label: (
                <div className="segmented-item">
                  <MessageTextIcon className="icon" />
                  <Text strong level="h5" className="segmented-text">
                    Announcement
                  </Text>
                </div>
              ),
              value: "announcement",
            },
          ]}
          className={css`
            width: 100%;
            // max-width: 326px;
            height: 48px;
            margin-bottom: 16px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            @media (max-width: 1200px) and (min-width: 800px) {
              max-width: 250px;
              height: 30px;
              padding: 0 2px;
            }

            @media (max-width: 1099px) {
              max-width: 100%;
            }

            .ant-segmented-item {
              height: 48px;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              gap: 8px;
              transition: background-color 0.3s
                cubic-bezier(0.645, 0.045, 0.355, 1);
              flex: 1;
              min-width: 0;

              @media (max-width: 1200px) and (min-width: 800px) {
                height: 30px;
                gap: 2px;
              }
            }

            .ant-segmented-item-selected {
              background-color: ${primaryColor};

              .segmented-text {
                color: ${isDefaultTheme ? "white" : "#230d39"} !important;
              }

              .icon {
                color: ${isDefaultTheme ? "white" : "#230d39"} !important;
              }
            }

            .segmented-item {
              display: flex;
              align-items: center;
              gap: 8px;
              height: 24px;
              min-width: 0;

              @media (max-width: 1200px) and (min-width: 800px) {
                gap: 2px;
              }
            }

            .icon {
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 0;
              margin-bottom: 0;
              flex-shrink: 0;

              @media (max-width: 1200px) and (min-width: 800px) {
                width: 12px;
                height: 12px;
              }

              @media (max-width: 1099px) {
                width: 10px !important;
                height: 10px !important;
              }
            }

            .segmented-text {
              font-size: 14px;
              font-weight: 700 !important;
              height: 24px;
              line-height: 24px;
              display: flex;
              align-items: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex-shrink: 1;
              min-width: 0;

              @media (max-width: 1200px) and (min-width: 800px) {
                font-size: 10px !important;
              }

              @media (max-width: 1099px) {
                font-size: 10px !important;
              }
            }
          `}
        />

        <div
          className={css`
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding-right: 4px;
            margin-right: -4px;
            position: relative;

            &::-webkit-scrollbar {
              width: 6px;
            }

            &::-webkit-scrollbar-track {
              background: ${isDefaultTheme ? "#f1f1f1" : "#2d1f45"};
              border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
              background: ${isDefaultTheme ? "#888" : "#4a3b61"};
              border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
              background: ${isDefaultTheme ? "#555" : "#5c4b75"};
            }
          `}
        >
          {loading ? (
            <div
              className={css`
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
              `}
            >
              <CustomLoaderIcon size="medium" color="black" />
            </div>
          ) : error ? (
            <div
              className={css`
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                text-align: center;
              `}
            >
              <MoreEmptyState
                type="MegaPhoneState"
                size="small"
                text="No data available"
              />
            </div>
          ) : !hasData ? (
            <div
              className={css`
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                text-align: center;
              `}
            >
              <MoreEmptyState
                type="EmptyState"
                size="small"
                text={`No ${
                  activeTab === "notification"
                    ? "notifications"
                    : "announcements"
                } available`}
              />
            </div>
          ) : (
            <>
              {currentData?.map((item, index) => (
                <div key={item._id || index}>
                  <div
                    className={css`
                      margin-bottom: 24px;
                      &:last-child {
                        margin-bottom: 8px;
                      }
                    `}
                  >
                    <div
                      className={css`
                        display: flex;
                        justify-content: space-between;
                        color: #9c92a6;
                        font-size: 12px;
                        margin-bottom: 4px;

                        @media (max-width: 576px) {
                          flex-direction: column;
                          align-items: flex-start;
                          gap: 4px;
                          font-size: 10px;
                        }
                      `}
                    >
                      <span
                        className={css`
                          @media (max-width: 1100px) {
                            font-size: 10px !important;
                          }
                        `}
                      >
                        {activeTab === "notification"
                          ? "NOTIFICATION:"
                          : "ANNOUNCEMENT:"}
                      </span>
                      <span
                        className={css`
                          color: ${isDefaultTheme
                            ? "#70627E"
                            : "#9c92a6"} !important;
                          @media (max-width: 576px) {
                            font-size: 9px;
                          }
                          @media (max-width: 1100px) {
                            font-size: 9px !important;
                          }
                        `}
                      >
                        {activeTab === "notification"
                          ? formatDateTime(item.createdAt)
                          : formatDateTime(item.date)}
                      </span>
                    </div>
                    <Title
                      className={css`
                        color: ${isDefaultTheme
                          ? "#230D39"
                          : "#9c92a6"} !important;
                        margin-bottom: 8px !important;
                        font-size: 12px !important;
                        font-weight: 600 !important;
                        line-height: 1.4 !important;

                        @media (max-width: 1099px) {
                          font-size: 10px !important;
                        }
                      `}
                    >
                      {item.title}
                    </Title>
                    <Text
                      className={css`
                        color: ${isDefaultTheme
                          ? "#230D39"
                          : "#ffffff"} !important;
                        font-size: 12px !important;

                        @media (max-width: 1099px) {
                          font-size: 10px !important;
                        }
                      `}
                    >
                      {item.description}
                    </Text>
                  </div>
                  {index < currentData.length - 1 && <Divider />}
                </div>
              ))}
              {(activeTab === "announcement" ||
                activeTab === "notification") && (
                <div style={{ textAlign: "center" }}>
                  <Button
                    type="link"
                    style={{
                      color: primaryColor,
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() => {
                      window.location.href = `${
                        process.env.REACT_APP_FE_HR_URL
                      }/${
                        userType === "admin" ? userType : "manager"
                      }/${activeTab}`;
                    }}
                  >
                    View all <ArrowRightIcon size={16} />
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </Card>
    </Col>
  );
};

export default NotificationCard;
